<template>
  <div class="copy">
    <div class="typed" v-html="currentText"></div>
  </div>
</template>

<script>
import anime from 'animejs/lib/anime.es.js'

export default {
  props: {
    text: {
      type: String,
      default: 'This is the text that will be typed.'
    },
    speed: {
      type: Number,
      default: 5
    },
    number: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      counter: 0,
      easedCounter: 0,
      initialized: false,
    }
  },
  computed: {
    currentText () {
      // return this.text.substring(0, this.easedCounter)
      const parts = this.text.split('<em>')
      let output = ''
      parts.forEach((segment) => {
        if (segment.includes('</em>')) {
          const subparts = segment.split('</em>')
          subparts[0] = subparts[0].replace(/\S/g, `<span class="letter-${this.number}"><em>$&</em></span>`)
          subparts[1] = subparts[1].replace(/\S/g, `<span class="letter-${this.number}">$&</span>`)
          segment = subparts[0] + subparts[1]
        } else {
          segment = segment.replace(/\S/g, `<span class="letter-${this.number}">$&</span>`)
        }
        output += segment
      })
      return output
    }
  },
  mounted () {
    anime.timeline({
      loop: 0
    }).add({
      loop: 0,
      targets: `.typed .letter-${this.number}`,
      opacity: [0,1],
      easing: 'easeInOutExpo',
      duration: 200,
      delay: (el, i) => i * 10
    })
  }
}
</script>
